import { SiteGroup } from "@abb-connect/react-shared";
import { buildServicesUrl } from "@services/routes";

export function getUrlToRedirectTo(siteGroups?: SiteGroup[]) {
  // Only one site exists in the hierarchy: skip selection and open it directly.
  if (siteGroups?.length === 1 && siteGroups[0]?.plants?.length === 1) {
    return buildServicesUrl([siteGroups[0].plants[0].name]);
  }

  return null;
}
